import { SharedState } from '@trello/shared-state';

export const atlassianIntelligenceFeedbackConsentState =
  new SharedState<boolean>(false);
